export default "__VITE_ASSET__D2taj$Y___"